import { toast } from 'react-toastify'
import i18n from '../i18n/i18n'

const tErrors = i18n.getFixedT(null, 'errors')

export const makeWarningToast = (detail) => {
	toast.warning(detail, {
		position: 'top-right',
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	})
}

export const makeErrorToast = (err) => {
	toast.error(err, {
		position: 'top-right',
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	})
}

export const CustomToastWithLink = ({ url, text }) => (
	<div>
		<a
			href={url}
			target="_blank"
			rel="noreferrer"
			style={{ color: 'inherit' }}
		>
			{text}
		</a>
	</div>
)

export const makeErrorToastWithLink = ({ url, text }) => {
	toast.error(<CustomToastWithLink url={url} text={text} />, {
		position: 'top-right',
		autoClose: 10000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	})
}

export const makeSuccessToast = (err) => {
	toast.success(err, {
		position: 'top-right',
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	})
}
export const msg = tErrors('unexpected')
